import React from "react";
import { ForwardedRef, forwardRef } from "react";
export const PayPal = forwardRef(function PayPalComponent(
  {
    currencyCode = "EUR",
    postUrl,
    companyEmail,
    amount,
    returnLink,
    notify_url,
    cancel_url,
    itemName,
    reservationId,
    openCard,
    dealerId,
    userId,
  }: {
    postUrl: string;
    reservationId: number;
    dealerId: number;
    userId: number;
    companyEmail: string;
    amount: number;
    returnLink: string;
    notify_url: string;
    cancel_url: string;
    currencyCode?: string;
    itemName: string;
    openCard: boolean;
  },
  ref: ForwardedRef<HTMLFormElement>
) {
  return (
    <>
      <form action={postUrl} method="post" target="_top" ref={ref}>
        <input type="text" name="cmd" value="_xclick" />
        <input type="text" name="business" value={companyEmail} />
        <input type="text" name="currency_code" value={currencyCode} />
        <input type="text" name="item_name" value={itemName} />

        <input type="text" name="amount" id="percentvaluetext" value={amount} />

        <input type="text" name="return" value={returnLink} />

        <input type="text" name="notify_url" value={notify_url} />

        <input type="text" name="cancel_url" value={cancel_url} />

        <input type="text" name="cbt" value="Torna al sito" />
        <input type="text" name="rm" value="2" />
        <input type="text" name="no_shipping" value="1" />
        <input type="text" name="UTF-8" value="charset" />
        <input type="text" name="paypal" value="page_style" />
        <input type="text" name="no_note" value="1" />
        <input
          type="text"
          name="custom"
          id="driver"
          value={`${reservationId}|${dealerId}|${userId}`}
        />

        <input type="text" name="privacy" id="privacy" value="0" />
        {openCard && (
          <input type="hidden" name="landing_page" value="Billing" />
        )}
        <input type={"submit"} value={"SUBMIT"} />
      </form>
    </>
  );
});
